import { z } from 'zod';
import { createFileRoute } from '@tanstack/react-router';

import RoleDetails from '@/modules/settings/pages/RoleDetails';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/roles/$roleId',
)({
  head: () => ({
    meta: [{ title: 'Detalhes da Função' }],
  }),
  parseParams: z.object({ roleId: z.coerce.number() }).parse,
  component: function RoleDetailsRoute() {
    const { roleId } = Route.useParams();

    return <RoleDetails id={roleId} />;
  },
});
